import analytics from 'analytics.js';
import events from 'events.js';

function trackSheetList(
    factsheets,
    user,
    category,
    drug,
    searchQuery,
    network,
) {
    const data = {
        ids: [],
        names: [],
        sponsors: [],
        sheetCount: factsheets.length,
        userName: user.name,
        userId: user.id,
        userType: user.userType,
        clinicalSoftware: user.practiceSoftware,
        userPostCode: user.postCode,
        source: 'healthshare',
        category,
        drug,
        searchQuery,
        network,
    };
    for (const fs of factsheets) {
        data.sponsors.push(fs.sponsor_name);
        data.names.push(fs.name);
        data.ids.push(fs.id);
    }
    analytics.track('sheetList', data);
}

(async function() {
    await events.ready();
    const dataset = document.body.dataset;

    const factsheets = [];

    for (const factsheet of JSON.parse(dataset.factsheets)) {
        factsheets.push({
            name: factsheet.fields.name,
            id: factsheet.pk,
            sponsor_name: factsheet.fields.sponsor,
        });
    }

    const userId = parseInt(dataset.id) || null;

    const siteUser = {
        name: dataset.name,
        id: userId,
        userType: dataset.userType,
        practiceSoftware: dataset.practiceSoftware,
        postCode: dataset.postCode,
    };

    const searchQuery = dataset.searchQuery;
    const category = dataset.category;
    const drug = dataset.drug;

    trackSheetList(factsheets, siteUser, category, drug, searchQuery);
})();
